import { Effect, EffectAttribute } from 'postprocessing'
import React, { forwardRef, useMemo } from 'react'

const WHITE_POINTS_FRAGMENT_SHADER = `
void mainImage(const in vec4 inputColor, const in vec2 uv, out vec4 outputColor) {
    // If the input color is black (point), output white with full opacity
    if (inputColor.rgb == vec3(0.0)) {
        outputColor = vec4(1.0, 1.0, 1.0, 1.0);
        return;
    }
    
    // Otherwise, keep the original color
    outputColor = inputColor;
}
`

class WhitePointsEffectImpl extends Effect {
  constructor() {
    super('WhitePointsEffect', WHITE_POINTS_FRAGMENT_SHADER, {
      uniforms: new Map(),
      attributes: EffectAttribute.CONVOLUTION,
    })
  }
}

export const WhitePointsEffect = forwardRef<
  WhitePointsEffectImpl,
  Record<string, never>
>(function WhitePointsEffect(props, ref) {
  const effect = useMemo(() => new WhitePointsEffectImpl(), [])
  return <primitive ref={ref} object={effect} dispose={null} />
})
